export default {
  "content": "<path d=\"M72.59 120c33.137 0 60-26.863 60-60s-26.863-60-60-60-60 26.863-60 60 26.863 60 60 60z\" fill=\"#838BF6\"/><path d=\"M91.99 49.366h-38.8a5.6 5.6 0 00-5.6 5.6V82.4a5.6 5.6 0 005.6 5.6h38.8a5.6 5.6 0 005.6-5.6V54.966a5.6 5.6 0 00-5.6-5.6z\" fill=\"#fff\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M72.59 22c9.353 0 16.935 7.582 16.935 16.935V51.78h-33.87V38.935C55.655 29.582 63.237 22 72.59 22zm0 2.415c-7.836 0-14.19 6.352-14.19 14.189v10.762h28.38V38.604c0-7.837-6.354-14.189-14.19-14.189z\" fill=\"#fff\"/><path d=\"M72.603 59.829h-.026a1.6 1.6 0 00-1.6 1.6v14.507a1.6 1.6 0 001.6 1.6h.026a1.6 1.6 0 001.6-1.6V61.429a1.6 1.6 0 00-1.6-1.6z\" fill=\"#838BF6\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "145",
    "height": "120",
    "viewBox": "0 0 145 120",
    "fill": "none"
  }
};